export const REACT_BASE_URL_GAMA_USERS = `${process.env.REACT_APP_APIGW_ENV}/api/v1/gama-users`;
export const REACT_BASE_URL_GAMA_AUTH = `${process.env.REACT_APP_APIGW_ENV}/api/v1/gama-auth`;
export const REACT_BASE_URL_GAMA_SHAREPOINT = `${process.env.REACT_APP_APIGW_ENV}/api/v1/gama-sharepoint`;
export const REACT_BASE_URL_GAMA_VEHICLES = `${process.env.REACT_APP_APIGW_ENV}/api/v1/gama-vehicles`;
export const API_KEY_MAPS = process.env.REACT_APP_API_KEY_MAPS;
export const STRAPI_API_URL = process.env.REACT_APP_STRAPI_API_URL;
export const SINISTER_API_URL = process.env.REACT_APP_SINISTER_API_URL;
